'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { FunnelType } from '@/models';

export const DataDogGlobal = ({ funnel }: { funnel: FunnelType }) => {
  useEffect(() => {
    datadogRum.setGlobalContextProperty('funnel', funnel);
  }, [funnel]);

  return null;
};
